import type { Post } from '@/payload-types'

const WORDS_PER_MINUTE = 200

function extractTextFromLexicalNode(node: unknown): string {
  if (!node || typeof node !== 'object') {
    return ''
  }

  const parts: string[] = []

  if ('text' in node && typeof node.text === 'string') {
    parts.push(node.text)
  }

  if ('children' in node && Array.isArray(node.children)) {
    for (const child of node.children) {
      parts.push(extractTextFromLexicalNode(child))
    }
  }

  if ('fields' in node && node.fields && typeof node.fields === 'object') {
    parts.push(extractTextFromValue(node.fields))
  }

  return parts.filter(Boolean).join(' ')
}

function extractTextFromValue(value: unknown): string {
  if (typeof value === 'string') {
    return value
  }

  if (Array.isArray(value)) {
    return value.map(extractTextFromValue).filter(Boolean).join(' ')
  }

  if (!value || typeof value !== 'object') {
    return ''
  }

  if ('root' in value) {
    return extractTextFromLexicalNode(value.root)
  }

  return Object.values(value).map(extractTextFromValue).filter(Boolean).join(' ')
}

function countWords(text: string): number {
  return text.trim().split(/\s+/).filter(Boolean).length
}

export function getPostReadingTimeMinutes(
  content: Post['content'] | null | undefined,
): number {
  const words = countWords(extractTextFromValue(content))

  if (words === 0) {
    return 1
  }

  return Math.max(1, Math.ceil(words / WORDS_PER_MINUTE))
}

export function formatReadTime(minutes: number, template: string): string {
  return template.replace('{minutes}', String(minutes))
}

export function getPostReadTimeLabel(
  content: Post['content'] | null | undefined,
  template: string,
): string {
  return formatReadTime(getPostReadingTimeMinutes(content), template)
}
